import { PaymentMethod } from '../types/items';


export const getMonthYearDate = (paymentMethod: PaymentMethod): string => {
  const { exp_year: expYear, exp_month: expMonth } = paymentMethod;

  if (!expMonth || !expYear) {
    return '';
  }

  const years = expYear.toString().slice(-2);
  const months = (expMonth < 10) ? `0${expMonth}` : expMonth;

  return `${months}/${years}`;
};

/**
 * example: **** **** **** 4242 (02/2022)
 */
export const getPaymentCardString = (paymentMethod: PaymentMethod) => {
  const expDate = getMonthYearDate(paymentMethod);

  return `**** **** **** ${paymentMethod.last_four_digits} (${expDate})`;
};
